<template>
  <div class="page">
    <div class="operation">
      <DiluButton type="add" @click="add" v-permission="['protocol:add']"/>
    </div>
    <DiluTable
      :list="tableData"
      :tableConfig="tableConfig"
    >
      <el-table-column
        prop="id"
        :label="$t('pages.equipment.text330')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        :label="$t('pages.equipment.text331')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="errorCounts"
        :label="$t('pages.equipment.text332')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="bikeTypeCounts"
        :label="$t('pages.equipment.text333')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="createdAt"
        :label="$t('pages.equipment.text334')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="address"
        :label="$t('public.text4')"
        align="center"
        width="250px"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button @click="edit(scope.row)" type="text">{{ $t("button.edit") }}</el-button>
            <el-button @click="del(scope.row)" type="text">{{ $t("button.delete") }}</el-button>
            <el-button @click="errorCode(scope.row)" type="text">{{ $t("pages.equipment.text335") }}</el-button>
          </div>
        </template>
      </el-table-column>
    </DiluTable>

    <!-- 新增弹窗 -->
    <ProtocolAdd @dialogClose="dialogClose" :dialogVisible="dialogVisible" :protocolInfo="protocolInfo" @protocolList="protocolList"/>

  </div>
</template>


<script>
import DiluButton from "../../../components/pubilc/dilu-button.vue";
import DiluTable from "../../../components/pubilc/dilu-table.vue";
import ProtocolAdd from "./module/protocolAdd";
import { mapState } from "vuex";
export default {
  data() {
    return {
      protocolInfo: {},
      dialogVisible: false, //新增编辑弹窗
      tableConfig: {
        isTree: false,
        isPage: false,
      },
      tableData: [],
    };
  },
  components: {
    DiluTable,
    DiluButton,
    ProtocolAdd,
  },
  computed: {
    ...mapState(["platformData"]),
  },
  mounted() {
    this.protocolList();
  },
  methods: {
    //获取协议列表
    protocolList() {
      this.request.protocolList().then((res) => {
        this.tableData = res.data;
      });
    },
    //关闭新增编辑弹窗
    dialogClose() {
      this.dialogVisible = false;
    },
    //重置
    reset() {
      this.protocolList();
    },
    //新增
    add() {
      this.protocolInfo = {};
      this.dialogVisible = true;
    },
    //删除
    del(e) {
      this.$confirm(
        this.$t("pages.equipment.text338"),
        this.$t("public.text6"),
        {
          confirmButtonText: this.$t("button.determine"),
          cancelButtonText: this.$t("button.cancel"),
          type: "warning",
        }
      )
      .then(() => {
        this.request
          .protocolDelete({
            protocolId: e.id
          })
          .then(() => {
            this.protocolList();
            this.$message({
              type: "success",
              message: this.$t("public.text7"),
            });
          });
      })
      .catch(() => {});
    },
    //修改
    edit(e) {
      this.protocolInfo = e;
      this.dialogVisible = true;
    },
    //错误代码
    errorCode(e) {
      this.protocolInfo=e;
      this.$router.push({
        path: "/equipment/errCode",
        query: {
          protocolId: this.protocolInfo.id,
        },
      });
    },
  },
};
</script>

<style scoped>
.page {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.from {
  float: left;
  display: flex;
}
.operation {
  margin-bottom: 20px;
  display: flex;
}
.image-slot {
  display: flex;
  align-items: center;
  justify-content: center;
}
.image-slot i {
  font-size: 20px;
}
</style>